import React from 'react';
import { withTrailingSlash } from '../../../utils/trailingSlash';

//@ts-ignore
import * as styles from './CtaButton.module.css';

interface Props {
    href: string;
    target?: string;
    color?: string;
    children?: React.ReactNode;
}

const CtaLink: React.FC<Props> = ({ href, target, color, children }) => {
    const inlineStyle: React.CSSProperties = {};

    if (color) {
        inlineStyle.color = color;
        inlineStyle.borderColor = color;
    }

    return (
        <>
            {color && <style>{`.${styles.ctaLink}`}</style>}
            <a
                href={withTrailingSlash(href)}
                target={target === '_new' ? '_blank' : target}
                className={`${styles.ctaLink}`}
                style={inlineStyle}
                rel={
                    [
                        target === '_blank' || target === '_new'
                            ? 'noopener noreferrer'
                            : '',
                        href.endsWith('.pdf') ? 'nofollow' : '',
                    ]
                        .filter(Boolean)
                        .join(' ') || undefined
                }
            >
                {children}
            </a>
        </>
    );
};

export default CtaLink;
